import React from 'react';
import { HashRouter, Route, Redirect } from 'react-router-dom';

import ErrorBoundary from '../../components/Error/ErrorBoundary';
import Authentication from '../../components/Authentication/Authentication';

export default function Routes() {
  return (
    <HashRouter>
      <ErrorBoundary>
        <Route component={Authentication} path="/" />
        <Redirect from="*" to="/" />
      </ErrorBoundary>
    </HashRouter>
  );
}
